module.exports = __webpack_public_path__ + "img/2024-07-01c_4.25c678d0.jpg";